export default __webpack_public_path__ + "static/media/4-BBQ.c4772297.png";